// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2hFg5","error":"Textarea_error__1ZiL0","readonly":"Textarea_readonly__1QdHL","disabled":"Textarea_disabled__14Z0_"};